import { render } from "./PagesDashboard.vue?vue&type=template&id=87f7ce56"
import script from "./PagesDashboard.vue?vue&type=script&lang=js"
export * from "./PagesDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/teslaelectric-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__